import React from 'react';
import { queryCache } from 'react-query';
import { QKeys } from 'src/api/types';
import { GTCInlineWrapper } from 'src/components/GenericTable';
import { useGTPortalTarget } from 'src/components/GenericTable/GTContext';
import { ControlStatusSelect } from 'src/components/select';
import { useUpsertControlMutation } from 'src/graphql/_generated';
import { showSuccessToast, toastMessages } from 'src/components/Toast';
import { useAuth } from 'src/state/auth';

interface StatusCellProps {
  controlId: string;
  value: string | null | undefined;
}

export const StatusCell: React.FC<StatusCellProps> = ({ controlId, value }) => {
  const [upsertControl, { loading }] = useUpsertControlMutation();
  const { workspaceId } = useAuth();
  const portalTarget = useGTPortalTarget();

  const handleChange = (option: { value: string }) => {
    if (option.value === value) return;
    upsertControl({
      variables: {
        controlData: { id: controlId, status: option.value },
        workspaceId,
      },
      update: (cache) => {
        cache.modify({
          id: cache.identify({ __typename: 'Control', id: controlId }),
          fields: {
            status: () => option.value,
          },
        });
      },
      onCompleted: () => {
        queryCache.invalidateQueries([QKeys.Audit]);
        showSuccessToast(toastMessages.control.updated);
      },
    });
  };

  return (
    <GTCInlineWrapper>
      <ControlStatusSelect value={value} onChange={handleChange} disabled={loading} menuPortalTarget={portalTarget} />
    </GTCInlineWrapper>
  );
};
